import React from 'react';
import { string, bool } from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { Form, PrimaryButton, FieldTextInput, IconEnquiry } from '../../components';
import * as validators from '../../util/validators';
import { propTypes } from '../../util/types';

import css from './CancelBookingForm.module.css';
import config from '../../config';

const CancelBookingFormComponent = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        submitButtonWrapperClassName,
        formId,
        handleSubmit,
        intl,
        currentUser,
        tx,
        cancelInProgress,
        cancelMeetingError,
      } = fieldRenderProps;

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = cancelInProgress;
      const submitDisabled = submitInProgress;
      const millisecondsTillMeeting = tx && tx.booking
        ? tx.booking.attributes.start.getTime() - Date.now() : 0;
      const isProvider =
        tx && tx.provider && currentUser && tx.provider.id.uuid === currentUser.id.uuid;
      const isDiscoveryMeeting = tx && tx.attributes.processName === 'discovery-meeting-process';

      let headingMessageId = null;
      if( isProvider ){
        if( isDiscoveryMeeting ){
          headingMessageId = 'CancelBookingForm.headingDiscoveryCancelByProvider';
        } else {
          headingMessageId = 'CancelBookingForm.headingCancelByProvider';
        }
      } else {
        if( isDiscoveryMeeting ){
          headingMessageId = 'CancelBookingForm.headingDiscoveryCancelByCustomer';
        } else {
          if( millisecondsTillMeeting > 48 * 60 * 60 * 1000 ) {
            headingMessageId = 'CancelBookingForm.headingCancelByCustomer';
          } else {
            headingMessageId = 'CancelBookingForm.headingCancelByCustomer48hours';
          }
        }
      }

      return (
        <Form className={classes} onSubmit={handleSubmit} enforcePagePreloadFor="OrderDetailsPage">
          <h2 className={css.heading}>
            <FormattedMessage id={headingMessageId} />
          </h2>
          <div className={submitButtonWrapperClassName}>
            {cancelMeetingError ? (
              <p className={css.error}>
                <FormattedMessage id="CancelBookingForm.sendEnquiryError" />
              </p>
            ) : null}
            <PrimaryButton type="submit" inProgress={submitInProgress} disabled={submitDisabled}>
              <FormattedMessage id="CancelBookingForm.submitButtonText" />
            </PrimaryButton>
          </div>
        </Form>
      );
    }}
  />
);

CancelBookingFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  submitButtonWrapperClassName: null,
  inProgress: false,
  sendEnquiryError: null,
};

CancelBookingFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  submitButtonWrapperClassName: string,

  inProgress: bool,

  listingTitle: string.isRequired,
  authorDisplayName: string.isRequired,
  sendEnquiryError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,
};

const CancelBookingForm = compose(injectIntl)(CancelBookingFormComponent);

CancelBookingForm.displayName = 'CancelBookingForm';

export default CancelBookingForm;
